import styled from "styled-components";

export const StoreWrapper = styled.div`
  width: 100%;
  padding-top: 53px;
  height: 100%;
  top: 100px;
  left: 0px;
  /* overflow: scroll; */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    overflow-x: hidden;
  }
`;

export const StoreLogo = styled.img`
  width: 183px;
  height: auto;
  @media only screen and (max-width: 480px) {
    width: 108px;
    margin-top: 8px;
  }
`;

export const Ul = styled.ul`
  list-style-type: none;
  margin-top: 62px;
  padding-left: 0px;
  @media only screen and (max-width: 850px) {
    display: flex;
    flex-direction: row;
    margin-top: 6px;
    justify-content: space-around;
    padding: 5px 10px;
    width: fit-content;
    margin-bottom: 0px;
    width: 100%;
    border-top: 0.5px solid black;
    border-bottom: 0.5px solid black;
  }
  @media only screen and (max-width: 480px) {
    display: flex;
    flex-direction: row;
    margin-top: 6px;
    justify-content: space-around;
    padding: 5px 10px;
    width: fit-content;
    margin-bottom: 0px;
    width: 100%;
    border-top: 0.5px solid black;
    border-bottom: 0.5px solid black;
  }
`;

export const Li = styled.li`
  cursor: pointer;
  font-family: "Futura Condensed";
  font-size: 20px;
  color: black;
  font-weight: 400;
  display: flex;
  align-items: center;
  height: 16px;
  margin: 0px 0px 22px 0px;
  @media only screen and (max-width: 850px) {
    font-size: 20px;
    margin: 10px 5px 10px 5px;
  }
  @media only screen and (max-width: 480px) {
    font-size: 16px;
    margin: 10px 5px 10px 5px;
  }
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border: 0.5px solid black;
  margin-right: 16px;
  background-color: ${props => (props.selectedSection ? "black" : "white")};
  cursor: pointer;
`;

export const StoreContainer = styled.div`
  width: calc(100% - 317px);
  margin-left: 317px;
  @media only screen and (max-width: 850px) {
    width: 100%;
    margin-left: 0px;
    margin-top: 185px;
    z-index: 99998;
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
    margin: 0px 0px 0px 0px;
    z-index: 99998;
  }
`;

export const ItemContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px;
  border-right: 0.5px solid black !important;
  border-bottom: 0.5px solid black;
  :last-child {
    border-right: 0px;
  }
  @media only screen and (max-width: 850px) {
    border-bottom: 0.5px solid black;
  }
  @media only screen and (max-width: 480px) {
    border-right: 0px;
    width: 100%;
    border-bottom: 0.5px solid black;
  }
`;

export const ItemImage = styled.img`
  height: 677px;
  width: 100%;
  object-fit: cover;
  @media only screen and (max-width: 1440px) {
    height: 600px;
  }
  @media only screen and (max-width: 1100px) {
    height: 640px;
  }
  @media only screen and (max-width: 800px) {
    height: 478.75px;
  }
  @media only screen and (max-width: 480px) {
    height: 500px;
  }
`;

export const SuggestedItemImage = styled.img`
  height: 677px;
  width: 100%;
  object-fit: cover;
  cursor: pointer;
  @media only screen and (max-width: 1440px) {
    height: 600px;
  }
  @media only screen and (max-width: 1100px) {
    height: 640px;
  }
  @media only screen and (max-width: 800px) {
    height: 478.75px;
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
    height: 208px;
    border-bottom: 0.5px solid black;
  }
`;

export const ItemDetailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
  overflow: hidden;
  height: fit-content;
`;

export const ItemDetailLeftColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  align-items: flex-start;
`;

export const ItemDetailRightColumn = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  align-items: flex-end;
`;

export const ItemTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
  margin-top: 10px;
  overflow: hidden;
  height: fit-content;
  @media only screen and (max-width: 480px) {
    margin-top: 0px;
  }
`;

export const SuggestedItemDetailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
  margin-top: 16px;
  overflow: hidden;
  height: fit-content;
  padding: 0px 24px;
  @media only screen and (max-width: 480px) {
    margin-top: 4px;
    padding: 0px 8px;
  }
`;

export const SuggestedItemDescContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
  overflow: hidden;
  height: fit-content;
  padding: 0px 24px;
  margin-top: 8px;
  @media only screen and (max-width: 480px) {
    margin-top: 0px;
    padding: 0px 8px;
  }
`;

export const ItemPrice = styled.span`
  font-size: 20px;
`;

export const ItemTitle = styled.span`
  font-size: 20px;
  cursor: pointer;
`;

export const SuggestedItemPrice = styled.span`
  font-size: 20px;
  @media only screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

export const SuggestedItemTitle = styled.span`
  font-size: 20px;
  cursor: pointer;
  @media only screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

export const ItemDesc = styled.span`
  font-size: 20px;
  width: 100%;
  cursor: pointer;
  height: fit-content;
  padding-bottom: 0px;
  margin: 0px;
  margin-bottom: 10px;
  @media only screen and (max-width: 480px) {
    margin-bottom: 0px;
  }
`;

export const SuggestedItemDesc = styled.span`
  font-size: 16px;
  width: 100%;
  cursor: pointer;
  height: fit-content;
  padding-bottom: 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width: 480px) {
    font-size: 12px;
    padding-bottom: 0px;
    height: 25px;
    margin-bottom: 4px;
    margin-top: -3px;
  }
`;

export const HeaderBox = styled.div`
  width: 317px;
  position: fixed;
  display: none;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  padding-top: 28px;
  border-right: 0.5px solid #000000;
  height: calc(100vh - 53px);
  @media only screen and (max-width: 850px) {
  }
  @media only screen and (max-width: 480px) {
    display: flex;
    /* position: sticky; */
    /* top: 0px; */
    width: 100%;
    border: 0px;
    padding-top: 0px;
    background-color: white;
    z-index: 99999;
    height: fit-content;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  @media only screen and (max-width: 850px) {
  }
  @media only screen and (max-width: 480px) {
    padding-top: 137px;
  }
`;

export const DetailContainer = styled.div`
  position: relative;
  height: 100%;
  width: 343px;
  @media only screen and (max-width: 850px) {
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
    height: fit-content;
    padding: 16px 16px 24px 16px;
    border-right: 0px;
  }
`;

export const EditNumberContainer = styled.div`
  width: 111px;
  height: 24px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: 0.5px solid black;
  margin: 10px 0px 16px 0px;
  @media only screen and (max-width: 480px) {
    border-top: 0.75px solid black;
  }
`;

export const EditNumberBlock = styled.div`
  width: 37px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  font-family: "Helvetica", "Arial", sans-serif;
`;

export const NumberBlock = styled.div`
  width: 37px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: default;
`;

export const BackToStoreButton = styled.button`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 0px;
  color: black !important;
  font-family: "Futura Condensed";
  font-size: 20px;
  border: 0.5px solid black;
  margin-top: 8px;
  @media only screen and (max-width: 480px) {
    border-top: 0.75px solid black;
  }
  :hover {
    box-shadow: 4px 4px 7px rgba(225, 225, 225, 0.9);
  }
`;

export const YouMayAlsoLike = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  border-top: 0.5px solid black;
  border-bottom: 0.5px solid black;
  @media only screen and (max-width: 850px) {
  }
  @media only screen and (max-width: 480px) {
    font-size: 16px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 480px) {
    flex-direction: column;
  }
`;

export const DesktopCol = styled.div`
  width: 50%;
  border-right: 0.5px solid black;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

export const Col = styled.div`
  width: 50%;
  padding-top: 137px;
  display: flex;
  justify-content: center;
  border-right: 0.5px solid black;
  @media only screen and (max-width: 480px) {
    border-right: 0px;
    padding-top: 0px;
    width: 100%;
  }
`;

export const MobileCol = styled.div`
  flex-grow: 1;
  display: none;
  @media only screen and (max-width: 480px) {
    display: block;
  }
`;

export const ItemDescriptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 20px;
  margin-top: 10px;
  overflow: hidden;
  height: fit-content;
  @media only screen and (max-width: 480px) {
    border-right: 0px;
  }
`;

export const BlackLine = styled.div`
  display: none;
  @media only screen and (max-width: 480px) {
    display: block;
    height: 0.5px;
    width: 100vw;
    margin-left: -16px;
    margin-top: 16px;
    margin-bottom: 16px;
    background-color: black;
  }
`;

export const BlackLineDesktop = styled.div`
  display: block;
  height: 0.5px;
  width: 100%;
  background-color: black;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;

export const StoreSection = styled.section`
  position: absolute;
  top: -53px;
  @media only screen and (max-width: 850px) {
  }
  @media only screen and (max-width: 480px) {
    top: -120px !important;
  }
`;

export const CTAContainer = styled.div`
  position: absolute;
  height: fit-content;
  width: 100%;
  bottom: 80px;
  @media only screen and (max-width: 480px) {
    position: relative;
    bottom: 0px;
  }
`;

export const CampaignContainer = styled.div`
  height: fit-content;
  width: 100%;
  position: relative;
  @media only screen and (max-width: 480px) {
    border-bottom: 0.75px solid black;
    padding-top: 194px;
  }
`;

export const CampaignImage = styled.img`
  width: 100%;
  height: auto;
  cursor: ${props => (props.disabled ? "default" : "pointer")};
  object-fit: cover;
  margin-top: 53px;
  @media only screen and (max-width: 850px) {
    margin-top: 53px;
    height: auto;
  }
  @media only screen and (max-width: 480px) {
    margin-top: 0px;
    width: 100%;
    height: auto;
    margin-bottom: 72px;
  }
  :hover {
    opacity: ${props => (props.disabled ? "1" : "0.9")};
  }
`;

export const CampaignButton = styled.div`
  position: absolute;
  width: 343px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 21px;
  margin-top: 16px;
  background-color: black;
  font-size: 16px;
  color: black;
  cursor: pointer;
  bottom: 30px;
  left: calc((100% - 343px) / 2);
  border: 0.5px solid black;
  :hover {
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.25);
    background-color: #212121;
  }
  @media only screen and (max-width: 480px) {
    width: calc(100% - 164px);
    height: 40px;
    bottom: 16px;
    left: 82px;
    /* padding: 0px 52px; */
  }
`;

export const DisabledCampaignButton = styled.div`
  position: absolute;
  width: 320px;
  height: 56px;
  padding: 0px 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  background-color: black;
  font-size: 20px;
  color: white;
  bottom: 30px;
  left: calc((100% - 320px) / 2);
  border: 0.5px solid black;
  cursor: default;
  @media only screen and (max-width: 480px) {
    width: calc(100% - 80px);
    font-size: 16px;
    height: 40px;
    bottom: 16px;
    left: 40px;
  }
`;
